import React from 'react';

const RegistrationSuccessPage = () => (
  <div className="register-success-conatiner vh-100">
    <div className="register-success d-flex flex-column align-items-center mx-auto">
      <h3 className="thanks-h3">Thanks for Registering</h3>
      <p className="my-4 thanks-p">
        Welcome. Please check your email for the activation link and verify your account.
        Once you have activated your account, you can access your enrolled courses and start learning.
      </p>
    </div>
  </div>
);

export default RegistrationSuccessPage;
